import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import { convertPxToRem } from '@webclient/lib/fonts';

import ToolbarExpansionButton from '@webclient/layouts/main/sections/toolbar/components/expand-button';
import WorkspacesPopover from '@webclient/layouts/main/sections/toolbar/components/workspaces-popover';
import CONFIG from '@webclient/layouts/main/sections/toolbar/config';
import RenderListItemIcon from '@webclient/layouts/main/sections/toolbar/mini/mobile/RenderListItemIcon';
import {
  StyledList,
  StyledMobileToolbar,
} from '@webclient/layouts/main/sections/toolbar/mini/mobile/styles';

export default function MobileToolbar() {
  return (
    <StyledMobileToolbar disableGutters>
      <Box sx={{ px: convertPxToRem(CONFIG.PATH_TO_SHOW_COLLAPSING_BUTTON) }}>
        <StyledList
          disablePadding
          direction="row"
          gap={2}
          component={Stack}
        >
          <WorkspacesPopover type="mobile" />
          <RenderListItemIcon />
        </StyledList>
      </Box>
      <ToolbarExpansionButton />
    </StyledMobileToolbar>
  );
}
